import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleMap from 'react-google-map';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import {
  isUserAgentMobile,
} from 'common/util/isUserAgentMobileApp';

import branch from 'client/core/branch';
import withGoogleMaps from 'client/helpers/withGoogleMaps';
import { defaultMapOptions } from 'client/constants/mapOptions';

import SrBox from 'client/components/SrBox';

const LocalMapContainer = ({ children }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrBox borderRadius={isSmallScreen ? '14px' : '24px'} padding='8px' backgroundColor='white'>
      <SrBox height='400px' borderRadius={isSmallScreen ? '6px' : '16px'} overflow='hidden'>
        {children}
      </SrBox>
    </SrBox>
  );
};

@withGoogleMaps
@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrAddressConfirmation extends Component {
  static propTypes = {
    formikBag: PropTypes.object.isRequired,
    googleMaps: PropTypes.object.isRequired,
    userAgent: PropTypes.object.isRequired,
  }

  _onLoadedMap = (googleMaps, map) => {
    const {
      formikBag,
    } = this.props;

    const iconImage = {
      url: '/images/home-map-pin.svg',
      size: new googleMaps.Size(87, 97),
      scaledSize: new googleMaps.Size(87, 97),
      origin: new googleMaps.Point(0, 0),
      anchor: new googleMaps.Point(43, 62),
    };

    this.marker = new googleMaps.Marker({
      position: {
        lat: formikBag.values.locationLatitude,
        lng: formikBag.values.locationLongitude,
      },
      map: map,
      icon: iconImage,
    });
  }

  render() {
    const {
      formikBag,
      googleMaps,
      userAgent,
    } = this.props;

    const isMobile = isUserAgentMobile(userAgent);

    return (
      <LocalMapContainer>
        <GoogleMap
          googleMaps={googleMaps}
          center={{
            lat: formikBag.values.locationLatitude,
            lng: formikBag.values.locationLongitude,
          }}
          zoomControl={!isMobile}
          zoomControlOptions={{
            position: googleMaps.ControlPosition.RIGHT_TOP,
          }}
          zoom={15}
          maxZoom='16'
          disableDefaultUI
          gestureHandling='cooperative'
          clickableIcons={false}
          onLoaded={this._onLoadedMap}
          options={defaultMapOptions}
        />
      </LocalMapContainer>
    );
  }
}

SrAddressConfirmation.displayName = 'SrAddressConfirmation';

export default SrAddressConfirmation;
